/* Functionality in /src/app.js under Gravity Forms */